import { useAppSelector } from "../../../../redux/store";
import { Backdrop, CircularProgress } from "@mui/material";

const Loading = () => {
  const { isLoading } = useAppSelector((state) => state.loading);
  return (
    <Backdrop open={isLoading} sx={{ zIndex: 1000 }}>
      <CircularProgress />
    </Backdrop>
  );
};

export default Loading;
